import { ConfirmDialog } from '@trellis/roots/overlays'

export function ImportRollbackDialog({
  open,
  onOpenChange,
  importedRows,
  onConfirm,
  isPending,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  importedRows: number
  onConfirm: () => void
  isPending: boolean
}) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Roll Back Import"
      description={
        <div className="space-y-2 text-sm">
          <p>
            This will attempt to delete all {importedRows} records created by this import.
          </p>
          <p className="text-amber-700">
            Records that have been modified or linked to other data may not be removed.
          </p>
        </div>
      }
      confirmLabel="Roll Back"
      pendingLabel="Rolling back…"
      tone="destructive"
      isPending={isPending}
      closeOnConfirm={false}
      onConfirm={onConfirm}
    />
  )
}
